import gsap from "gsap";
import type { MutableRefObject } from "react";

/**
 * Показує / ховає оверлей лоадера при freezeUI без спалаху при першому монті:
 * hide-анімація лише після того, як freeze хоч раз був активний.
 */
export function syncFreezeTextLoaderAnimation(
	element: HTMLElement | null,
	isFreezeUI: boolean,
	freezeWasActiveRef: MutableRefObject<boolean>,
): void {
	if (!element) return;

	if (isFreezeUI) {
		freezeWasActiveRef.current = true;
		gsap.fromTo(
			element,
			{ opacity: 0, scale: 0.9, y: 15, pointerEvents: "none" },
			{
				opacity: 1,
				scale: 1,
				y: 0,
				duration: 0.5,
				ease: "elastic.out(1.7, 1.4)",
				pointerEvents: "auto",
			},
		);
	} else if (freezeWasActiveRef.current) {
		gsap.fromTo(
			element,
			{ opacity: 1, scale: 1, y: 0 },
			{
				opacity: 0,
				scale: 0.96,
				y: 10,
				duration: 0.3,
				ease: "power2.inOut",
				pointerEvents: "none",
			},
		);
	} else {
		gsap.set(element, {
			opacity: 0,
			scale: 0.9,
			y: 15,
			pointerEvents: "none",
		});
	}
}
